'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _caseTypes = require('./case-types.js');

var _caseTypes2 = _interopRequireDefault(_caseTypes);

var _stringUtil = require('../util/string-util.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Case = function () {
  function Case(func, pattern, type) {
    _classCallCheck(this, Case);

    this.resultFunction = func;
    this.pattern = pattern;
    this.type = type;
  }

  _createClass(Case, [{
    key: 'getPattern',
    value: function getPattern() {
      return this.pattern;
    }
  }, {
    key: 'getResultFunction',
    value: function getResultFunction() {
      return this.resultFunction;
    }
  }, {
    key: 'matches',
    value: function matches(value) {
      return this.type.matches(value, this.getPattern());
    }
  }, {
    key: 'binds',
    value: function binds() {
      return this.type.binds();
    }
  }]);

  return Case;
}();

var CaseBuilder = function () {
  function CaseBuilder() {
    _classCallCheck(this, CaseBuilder);
  }

  _createClass(CaseBuilder, null, [{
    key: 'types',
    value: function types() {
      return _caseTypes2.default;
    }
  }, {
    key: 'build',
    value: function build(caseDefinition) {
      return new Case(this.getCaseFunction(caseDefinition), this.getCasePattern(caseDefinition), this.getCaseType(caseDefinition));
    }
  }, {
    key: 'isBabelized',
    value: function isBabelized(caseDefinition) {
      var r = Boolean(caseDefinition.pattern) && Boolean(caseDefinition.function);
      return r;
    }
  }, {
    key: 'getCaseFunction',
    value: function getCaseFunction(caseDefinition) {
      return this.isBabelized(caseDefinition) ? caseDefinition.function : caseDefinition;
    }
  }, {
    key: 'getCasePattern',
    value: function getCasePattern(caseDefinition) {
      return this.isBabelized(caseDefinition) ? caseDefinition.pattern : this.buildPattern(caseDefinition);
    }
  }, {
    key: 'getCaseType',
    value: function getCaseType(caseDefinition) {
      var _this = this;

      return CaseBuilder.types().find(function (type) {
        return type.applysFor(_this.getCasePattern(caseDefinition));
      });
    }
  }, {
    key: 'isValuePattern',
    value: function isValuePattern(parameters) {
      return parameters.includes("=");
    }
  }, {
    key: 'buildPattern',
    value: function buildPattern(caseDefinition) {
      var cleanString = (0, _stringUtil.withoutWhitespaces)(caseDefinition.toString());
      var parameters = cleanString.slice(cleanString.indexOf("(") + 1, cleanString.indexOf(")=>"));
      return this.isValuePattern(parameters) ? (0, _stringUtil.substringFrom)(parameters, "=") : parameters;
    }
  }]);

  return CaseBuilder;
}();

exports.default = CaseBuilder;